<template>
  <div class="swiper-item-main" v-if="source">
    <div class="swiper-item-tile">
      <div class="tile-image-wrapper">
        <img class="tile-image lazyloaded" :src="source.src" :alt="source.alt || source.title" />
        <div class="tile-name text--center" v-if="source.logo">
          <img class="tile__logo lazyloaded" :src="source.logo" :alt="source.alt || source.title" />
        </div>
      </div>
      <h3 class="tile-title">
        <a @click="actionHandler(source.action)" class="tile-wrapper-link">
          <span class="sr-only">{{source.title}}</span>
        </a>
      </h3>
      <div class="tile-body">
        <div class="tile-desc">{{source.desc || source.title}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import actionMixins from "@/utils/action.mixins";

export default {
  name: "CircleItem",
  mixins: [actionMixins],
  props: {
    source: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .tile-name { color: #000; margin-top: .3125rem; overflow: hidden; text-transform: none; }
  .swiper-item-main {
    margin: 0 auto;
    .swiper-item-tile {
      position: relative;
      max-width: 100%;
      .tile-image-wrapper {
        position: relative;
        z-index: -1;
        .tile-image {
          border-radius: 50%;
          transition: opacity .3s;
          width: 100%;
        }
        .tile-name {
          margin: 0;
          position: absolute;
          bottom: -1.5625rem;
          height: 2.3125rem;
          width: 100%;
          .tile__logo { max-width: 100%; max-height: 100%; }
        }
      }
      .tile-title {
        .tile-wrapper-link {
          display: inline-block;
          overflow: hidden;
          text-decoration: none;
          width: 100%;
          font-family: HelveticaNeueLTW05-45Light,arial,sans-serif;
          font-size: .8125rem;
          &::before {
            content: "";
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            position: absolute;
            z-index: 1;
          }
        }
      }
      .tile-body {
        text-align: left;
        position: relative;
        .tile-desc {
          margin-top: 2.1875rem;
          font-size: .75rem;
          height: 2.375rem;
          overflow: hidden;
          color: #575757;
          text-align: center;
        }
      }
    }
  }
  @media screen and (min-width: 48em) {
    .tile-name { margin-top: .75rem; }
  }
  @media screen and (min-width: 64em) {
    .swiper-item-main {
      .swiper-item-tile {
        max-width: 24.3125rem;
        margin: 0 auto;
        .tile-image-wrapper {
          .tile-name {
            height: 3.125rem;
          }
        }
        &:hover {
          .tile-image-wrapper {
            .tile-image { opacity: 0.4; }
          }
        }
      }
    }
  }
</style>